"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_TYPE_LABELS = exports.projectTypeLabel = exports.PROJECT_TYPE_REGISTRY = void 0;
exports.PROJECT_TYPE_REGISTRY = {
    VERANDA: {
        label: 'Véranda',
        cardTitle: 'Véranda',
        description: 'Extension vitrée fermée et chauffée',
        accentColor: '#047a48',
        accentBg: '#d6f0e6',
    },
    PERGOLA: {
        label: 'Pergola',
        cardTitle: 'Pergola / Carport',
        description: 'Structure ouverte, abri voiture',
        accentColor: '#b45309',
        accentBg: '#fef3c7',
    },
    POOL: {
        label: 'Piscine',
        cardTitle: 'Piscine',
        description: 'Bassin enterré ou semi-enterré',
        accentColor: '#0e7490',
        accentBg: '#cffafe',
    },
};
// Short label for a project type (canonical display string).
const projectTypeLabel = (type) => exports.PROJECT_TYPE_REGISTRY[type].label;
exports.projectTypeLabel = projectTypeLabel;
// `{ VERANDA: 'Véranda', ... }` — the flat label map several call sites expect.
exports.PROJECT_TYPE_LABELS = {
    VERANDA: exports.PROJECT_TYPE_REGISTRY.VERANDA.label,
    PERGOLA: exports.PROJECT_TYPE_REGISTRY.PERGOLA.label,
    POOL: exports.PROJECT_TYPE_REGISTRY.POOL.label,
};
//# sourceMappingURL=project-types.js.map